import createVueApp from '@/common/create_app'

const adminOrgSidebar = (orgId, { hasHubspot = false } = {}) => {
  const base = `/admin/organizations/${orgId}`
  const items = [
    { label: 'Overview', href: base, icon: 'fa-solid fa-circle-info', activeUrl: base, activeExact: true },
    { label: 'Settings', href: `${base}/settings`, icon: 'fa-solid fa-sliders', activeUrl: `${base}/settings` },
    { label: 'Members', href: `${base}/members`, icon: 'fa-solid fa-users', activeUrl: `${base}/members` },
    { label: 'Stripe', href: `${base}/stripe_events`, icon: 'fa-brands fa-stripe-s', activeUrl: `${base}/stripe_events` }
  ]
  if (hasHubspot) {
    items.push({ label: 'HubSpot', href: `${base}/hubspot_webhooks`, icon: 'fa-brands fa-hubspot', activeUrl: `${base}/hubspot_webhooks` })
  }
  return { items }
}

async function initAdminOrgPage(componentImport, props) {
  const [{ default: Component }, { default: AdminOrgLayout }] = await Promise.all([
    componentImport,
    import('@/vue_widgets/admin/organizations/show/AdminOrgLayout.vue')
  ])
  createVueApp(Component, {
    props,
    layout: AdminOrgLayout,
    layoutProps: { organization: props.organization },
    sidebar: adminOrgSidebar(props.organization.id, { hasHubspot: !!props.organization.hasHubspot })
  })
}

Styxie.Initializers.AdminOrganizations = {
  index: async(props) => {
    const { default: OrganizationsIndex } = await import('@/vue_widgets/admin/organizations/index/index.vue')
    createVueApp(OrganizationsIndex, { props })
  },
  show: async(props) => initAdminOrgPage(import('@/vue_widgets/admin/organizations/show/OverviewTab.vue'), props),
  settings: async(props) => initAdminOrgPage(import('@/vue_widgets/admin/organizations/show/SettingsTab.vue'), props)
}

Styxie.Initializers.AdminOrganizationsMembers = {
  index: async(props) => initAdminOrgPage(import('@/vue_widgets/admin/organizations/show/MembersTab.vue'), props)
}

Styxie.Initializers.AdminOrganizationsStripeEvents = {
  index: async(props) => initAdminOrgPage(import('@/vue_widgets/admin/organizations/show/StripeTab.vue'), props)
}

Styxie.Initializers.AdminOrganizationsHubspotWebhooks = {
  index: async(props) => initAdminOrgPage(import('@/vue_widgets/admin/organizations/show/HubspotTab.vue'), props)
}
